import { Component, OnInit, Input } from '@angular/core';

const iconByAlertType = {
  success: 'check_circle',
  error: 'cancel',
  info: 'info',
  warning: 'error_outline',
};

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  @Input()
  type: 'success' | 'error' | 'info' | 'warning' | 'brand' = 'success';

  @Input()
  title: string;

  @Input()
  dense = false;

  @Input()
  hideIcon = false;

  @Input()
  customIcon?: string;

  constructor() { }

  ngOnInit(): void {
  }

  get icon() {
    if (this.customIcon) { return this.customIcon; }

    return iconByAlertType[this.type];
  }

  get isIconFlat() {
    return this.type === 'success' || this.type === 'error';
  }

}
